import React from 'react';
import './WelcomeImage.css';

function WelcomeImage({ backgroundImage, name1, name2, plusText, textColor = '#FFFFFF' }) {
  return (
    <div className="welcome-container">
      <img 
        src={backgroundImage} 
        alt="Welcome background" 
        className="welcome-background"
      />
      <div className="names-container" style={{ color: textColor }}>
        <div className="names-layout">
          <h1 className="name-large top">{name1}</h1>
          <h2 className="plus">{plusText}</h2>
          <h1 className="name-large bottom">{name2}</h1>
        </div>
      </div>
    </div>
  );
}

export default WelcomeImage; 